export default function() {
  return (['cancelFullScreen', 'mozCancelFullScreen', 'webkitCancelFullScreen'].findIndex((propName) => (typeof document[propName] !== 'undefined')) !== -1)
}